import types from '../actions/types';
import produce from "immer/dist/immer";

const initialState = window.tProjectGlobals.initialStates.stickers;
initialState.keyword = '';
initialState.searchResult = [];

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.SET_STICKER_CATEGORY:
      return produce(state, draftState => {
        draftState.currentCategory = action.payload.category;
        draftState.keyword = '';
        draftState.searchResult = [];
      });
    case types.RESET_STICKER_KEYWORD:
      return produce(state, draftState => {
        draftState.keyword = '';
        draftState.searchResult = [];
      });
    case types.SEARCH_STICKER:
      return produce(state, draftState => {
        draftState.keyword = action.payload.keyword;
      });
    case types.FETCH_STICKER_SUCCESS:
      return produce(state, draftState => {
        draftState.keyword = action.payload.keyword;
        draftState.searchResult = (action.payload.stickers || []);
      });
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/stickersReducer.js